import React from 'react'
import { DOCUMENT_FORM, documentFormSelector } from '../../../services/forms'
import { EditorState, convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import { createDocument } from '../../../actions/documentsActions'
import DocumentForm from '../form/DocumentForm'
import { change, formValueSelector, submit } from 'redux-form'
import FormTop from '../../form/FormTop'
import { uploadFile } from '../../../services/http'
import { documentModel } from '../../../models/documentModel'
import { EditTop } from '../../general/EditTop'
import { loadProvenancePersons } from '../../../actions/provenancePersonsActions'
import { loadProvenanceInstitutions } from '../../../actions/provenanceInstitutionsActions'
import { loadExhibitionsBasic } from '../../../actions/exhibitionsActions'
import { loadArtworksForMentionsAction } from '../../../actions/artworksActions'
import DataProviderFunctional from '../../loader/DataProviderFunctional'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'

export const DocumentCreatePresentation = () => {
  let { id } = useParams()
  const selector = formValueSelector(DOCUMENT_FORM)
  const lang = useSelector((state) => state.translations.language)
  const initialValues = documentModel
  const saveState = useSelector((state) => state.documents.saveState)
  const type = useSelector((state) => selector(state, 'type'))
  const dispatch = useDispatch()
  const onSubmit = (data) => {
    const documents_pages = data.documents_pages.map((p) => {
      const transcription = p.transcription ? p.transcription : EditorState.createEmpty()
      const translation = p.translation ? p.translation : EditorState.createEmpty()
      const rawStateTranscription = convertToRaw(transcription.getCurrentContent())
      const rawStateTranslation = convertToRaw(translation.getCurrentContent())

      return {
        ...p,
        transcription_state: JSON.stringify(rawStateTranscription),
        transcription_html: draftToHtml(rawStateTranscription),
        translation_state: JSON.stringify(rawStateTranslation),
        translation_html: draftToHtml(rawStateTranslation),
      }
    })
    dispatch(createDocument({ ...data, documents_pages: documents_pages, id: id }))
  }
  const remoteSubmit = () => dispatch(submit(DOCUMENT_FORM))
  const changeFieldValue = (field, value) => dispatch(change(DOCUMENT_FORM, field, value))
  const upload = uploadFile

  return (
    <div>
      <div className="Exhibition-controls">
        <EditTop title="Create Document" />

        <div className="controls">
          <FormTop button="Save Document" remote={remoteSubmit} saveState={saveState} />
        </div>
      </div>

      <div className="Exhibition-grid">
        {/* <NavigationPrompt when={dirty} /> */}
        <DocumentForm
          lang={lang}
          onSubmit={onSubmit}
          changeFieldValue={changeFieldValue}
          initialValues={initialValues}
          upload={upload}
          type={type}
        />
      </div>
      <div />
    </div>
  )
}

const DocumentCreate = () => {
  const loading = useSelector(state => state.documents.state)
  const error = useSelector((state) => state.documents.error)
  const dispatch = useDispatch()
  const load = () => {
    dispatch(loadProvenancePersons())
    dispatch(loadExhibitionsBasic())
    dispatch(loadProvenanceInstitutions())
    dispatch(loadArtworksForMentionsAction())
  }
  return (
    <DataProviderFunctional
      error={error}
      load={load}
      loading={loading}
      component={DocumentCreatePresentation}
    />
  )
}

export default DocumentCreate
